import React from 'react';
import ShippingForm from '../Forms/ShippingForm/ShippingForm';
import CartHeader from '../ShoppingCart/CartHeader';

function MemberAddNewShipping({
	setStep,
	defaultValues,
	backToStep,
	updateExistingShippingAddress,
	addShippingAddressToProfile,
	message,
}) {
	const handleFormSubmission = (data) => {
		if (defaultValues) {
			updateExistingShippingAddress(data, defaultValues.addressId);
		} else {
			addShippingAddressToProfile(data);
		}
	};

	return (
		<>
			<CartHeader title='Checkout' />
			{message && (
				<div className={`mb-20 alert ${message?.class}`}>{message.message}</div>
			)}
			<div className='subtitle mb-16 lower roboto'>
				Add Personal Information
			</div>
			<ShippingForm
				handleFormSubmission={handleFormSubmission}
				setStep={setStep}
				defaultValues={defaultValues}
				backToStep={backToStep}
			/>
		</>
	);
}

export default MemberAddNewShipping;
